var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _circle4, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNotifications = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 250 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2F8",
  fillRule: "evenodd",
  d: "M63 134h91q.774-.002 1.5-.161.726.16 1.5.161h52a7 7 0 1 0 0-14h-6a7 7 0 1 1 0-14h19a7 7 0 1 0 0-14h-22a7 7 0 1 0 0-14h-64a7 7 0 1 0 0-14H79a7 7 0 1 0 0 14H39a7 7 0 1 0 0 14h25a7 7 0 1 1 0 14H24a7 7 0 1 0 0 14h39a7 7 0 1 0 0 14m163 0a7 7 0 1 0 0-14 7 7 0 0 0 0 14",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M95.047 102.097c0-16.289 13.205-29.494 29.494-29.494s29.495 13.205 29.495 29.494v30.91h-58.99z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M95.047 102.097c0-16.289 13.205-29.494 29.494-29.494s29.495 13.205 29.495 29.494v30.91h-58.99z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "M95.047 102.097c0-16.289 13.205-29.494 29.494-29.494s29.495 13.205 29.495 29.494v30.91h-58.99z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#960145",
  d: "M83 136.172a5.66 5.66 0 0 1 5.66-5.66h73.588a5.66 5.66 0 1 1 0 11.321H88.661A5.66 5.66 0 0 1 83 136.172"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.2,
  d: "M83 136.172a5.66 5.66 0 0 1 5.66-5.66h73.588a5.66 5.66 0 1 1 0 11.321H88.661A5.66 5.66 0 0 1 83 136.172"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#BE185D",
  d: "M125.454 152c6.253 0 11.321-5.069 11.321-11.321h-22.642c0 6.252 5.069 11.321 11.321 11.321"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M125.454 152c6.253 0 11.321-5.069 11.321-11.321h-22.642c0 6.252 5.069 11.321 11.321 11.321Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "M125.454 152c6.253 0 11.321-5.069 11.321-11.321h-22.642c0 6.252 5.069 11.321 11.321 11.321Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 124.541,
  cy: 67.687,
  r: 3.687,
  fill: "#960145"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 124.541,
  cy: 67.687,
  r: 3.687,
  fill: "#000",
  fillOpacity: 0.2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 124.541,
  cy: 67.687,
  r: 3.687,
  stroke: "#960145",
  strokeLinejoin: "round",
  strokeWidth: 3
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 124.541,
  cy: 67.687,
  r: 3.687,
  stroke: "#000",
  strokeLinejoin: "round",
  strokeOpacity: 0.2,
  strokeWidth: 3
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BE185D",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M124 83c-1.273 0-2.518.125-3.721.364m-3.634 1.112C109.804 87.351 105 94.114 105 102"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#BE185D",
  strokeWidth: 2,
  d: "M134 51a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM88 80a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#BE185D",
  d: "M161 73a3 3 0 1 0 0-6 3 3 0 0 0 0 6M71 62a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BE185D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M174 40v6M174 54v6M164 50h6M178 50h6M68 148v4M68 160v4M60 156h4M72 156h4"
})));
export default SvgNotifications;